import { actions } from 'react/api/actions/taskScheduler';
import { fromJS } from 'immutable';

const initialState = fromJS({
  loadingSchedulers: true,
  loadingLogs: false,
  taskSchedulers: [],
  logs: [],
  activeLog: null,
  errorIndex: null
});

export default (state = initialState, action) => {
  switch (action.type) {

    case actions.requestTaskSchedulers: {
      return state.set('loadingSchedulers', true);
    }

    case actions.requestTaskSchedulersSuccess: {
      const { payload: { response } } = action;
      return state.merge({
        'taskSchedulers': response,
        'loadingSchedulers': false
      });
    }

    case actions.executeTaskScheduler: {
      const { payload: { executingIndex } } = action;
      return state.setIn(['taskSchedulers', executingIndex, 'isExecuting'], true);
    }

    case actions.executeTaskSchedulerSuccess: {
      const { payload: { executingIndex } } = action;
      return state.setIn(['taskSchedulers', executingIndex, 'isExecuting'], false);
    }

    case actions.executeTaskSchedulerError: {
      const { payload: { executingIndex } } = action;
      state = state.setIn(['taskSchedulers', executingIndex, 'isExecuting'], false);
      return state.set('errorIndex', executingIndex);
    }

    case actions.hideTaskSchedulerAlert: {
      const { executingIndex } = action && action.payload || {};
      if (!executingIndex || executingIndex === state.get('errorIndex')) {
        state = state.set('errorIndex', null);
      }
      return state;
    }

    case actions.requestTaskSchedulerLogs: {
      const { payload: { activeLog } } = action;
      return state.merge({
        'activeLog': activeLog,
        'loadingLogs': true
      });
    }

    case actions.requestTaskSchedulerLogsSuccess: {
      const { payload: { response } } = action;
      return state.merge({
        'logs': response,
        'loadingLogs': false,
      });
    }

    case actions.closeTaskSchedulerLogs: {
      return state.merge({
        'activeLog': null,
        'loadingLogs': false,
        'logs': []
      });
    }

    case actions.clearTaskSchedulerState: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
